// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"9d99b479","787":"9c62f818"}[chunkId] + ".chunk.js";
};